<template lang="pug">
  e-form-group(
  :name="fieldName"
  inputType="select"
  label="Тип объекта"
    :model="fields"
      :options="options"
      :tabView="tabView"
      :formGroupStyle="formGroupStyle"
      :required="required"
  )
</template>
<script>
  import reportFieldMixin from '../../mixins/report-field-mixin'
  import {GARBAGE_HEAP, GARBAGE_ORO} from '../../utils/types'

  export default {
    mixins: [reportFieldMixin],
    name: 'heap-type',
    created () {
      this.$set(this.fields, this.fieldName, '')
    },
    computed: {
      fieldName () {
        return 'heapType'
      },
      options () {
        return [
          {id: GARBAGE_HEAP, name: 'Навалы мусора'},
          {id: GARBAGE_ORO, name: 'Несанкционированные ОРО'}
        ]
      }
    }
  }
</script>
